import { InjectionToken } from '@angular/core';
import { internalErrorConfig } from '../error-config/error-config.config';

export const INTERNAL_ERROR_CONFIG: InjectionToken<typeof internalErrorConfig> =
  new InjectionToken('Internal_Error_Config');

export const internalErrorFactory = (): typeof internalErrorConfig => internalErrorConfig;
